<template>
  <ValidationProvider name="email template" slim vid="email_template">
    <template #default="{ errors }">
      <BaseFormGroup>
        <VSelect
          v-model="modelValue"
          :options="options"
          placeholder="Select email template"
          label="name"
          :disabled="disabled"
          :filterable="false"
          class="vue-select max-w-lg"
          @search="onSearch"
        >
          <template v-if="hasMore" #list-footer>
            <li class="flex space-x-2 px-2 pt-2 mb-1">
              <BaseButton
                primary
                outline
                small
                :disabled="!hasPrevPage"
                class="flex-1"
                @click="fetchPrevPage"
              >
                Prev
              </BaseButton>
              <BaseButton
                primary
                outline
                small
                :disabled="!hasNextPage"
                class="flex-1"
                @click="fetchNextPage"
              >
                Next
              </BaseButton>
            </li>
          </template>
        </VSelect>
        <BaseFormInlineMessage v-if="errors.length" danger>
          {{ errors[0] }}
        </BaseFormInlineMessage>
      </BaseFormGroup>
    </template>
  </ValidationProvider>
</template>

<script>
import { debounce } from 'lodash-es';
import { accountEmailTemplatesClient } from '@/api/clients';

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    accountId: {
      type: String,
      required: true,
    },
    disabled: Boolean,
  },
  data() {
    return {
      options: [],
      meta: null,
      search: '',
      page: 1,
    };
  },
  computed: {
    modelValue: {
      get() {
        return this.options.find((option) => option.id === this.value) || null;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    hasPrevPage() {
      return (this.meta?.current_page || 1) > 1;
    },
    hasNextPage() {
      return (this.meta?.last_page || 1) > (this.meta?.current_page || 1);
    },
    hasMore() {
      return this.meta?.last_page > 1;
    },
  },
  created() {
    this.fetchOptions();
  },
  methods: {
    selectable(option) {
      return this.value.findIndex((item) => item.id === option.id) === -1;
    },
    onSearch(search, loading) {
      loading(true);
      this.searchOptions(loading, search, this);
    },
    searchOptions: debounce((loading, search, vm) => {
      // eslint-disable-next-line no-param-reassign
      vm.search = search;
      vm.fetchOptions().finally(() => loading(false));
    }, 350),
    async fetchOptions() {
      try {
        const response = await accountEmailTemplatesClient.list(this.accountId, {
          filter: {
            search: this.search,
          },
          page: this.page,
        });

        this.setOptions(response.data);
        this.setMeta(response.meta);

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    setOptions(options) {
      this.options = options;
    },
    setMeta(meta) {
      this.meta = meta;
    },
    fetchPrevPage() {
      if (!this.hasPrevPage) {
        return;
      }
      this.page = this.meta.current_page - 1;
      this.fetchOptions();
    },
    fetchNextPage() {
      if (!this.hasNextPage) {
        return;
      }
      this.page = this.meta.current_page + 1;
      this.fetchOptions();
    },
  },
};
</script>
